import { createHeadlessEditor } from '@lexical/headless';
import { Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { $getRoot } from 'lexical';
import { noop } from 'lodash-es';
import { UserAvatarList } from '../../../../../components/AvatarListTooltip/UserAvatarList';
import { Commentary } from '../../../../../schemas/Commentary.schema';
import { FMT } from '../../../../../util/formatter-service';

const SUMMARY_MAX_CHAR = 250;

const CommentarySummaryCardWrapper = styled('div')`
  display: grid;
  height: 100%;
  row-gap: 0.5rem;
  width: 100%;
`;

const CommentaryTextWrapper = styled('div')`
  background: ${(props) => props.theme.palette.background.paper};
  border-radius: 0.25rem;
  overflow: hidden;
  padding: 0.75rem;
  position: relative;
  border: thin solid transparent;
  transition: border-color 0.2s;
`;

const ClickableCommentaryTextWrapper = styled(CommentaryTextWrapper)`
  cursor: pointer;
  :hover {
    border-color: ${(props) => props.theme.palette.secondary.main};
  }
`;

interface ICommentarySummaryCardProps {
  commentary: Commentary;
  onEditClick?: () => void;
}

export function CommentarySummaryCard({ commentary, onEditClick }: ICommentarySummaryCardProps) {
  const commentaryText = getCommentaryText(commentary);
  const TextWrapper = onEditClick ? ClickableCommentaryTextWrapper : CommentaryTextWrapper;

  return (
    <CommentarySummaryCardWrapper>
      <Stack>
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
          <Stack direction={'row'} alignItems={'center'} gap={'0.5rem'}>
            <UserAvatarList users={[]} />
            <Typography variant={'caption'} color={'text.secondary'}>{`${FMT.format(
              'date',
              commentary.createdAt
            )} at ${FMT.format('time12hr', commentary.createdAt)}`}</Typography>
          </Stack>
        </Stack>
      </Stack>

      <TextWrapper onClick={onEditClick}>
        <Typography variant={'body2'}>{commentaryText}</Typography>
      </TextWrapper>
    </CommentarySummaryCardWrapper>
  );
}

export function getCommentaryText(commentary: Commentary) {
  if (!commentary.text) {
    return '';
  }
  try {
    const editor = createHeadlessEditor({ nodes: [], onError: noop });
    const parsedEditorState = editor.parseEditorState(commentary.text);
    const text = parsedEditorState.read(() => $getRoot().getTextContent());
    return text.length > SUMMARY_MAX_CHAR ? `${text.slice(0, SUMMARY_MAX_CHAR)}...` : text;
  } catch {
    return commentary.text.slice(0, SUMMARY_MAX_CHAR);
  }
}
